(() => {
  'use strict';
  const init = (root = document) => {
    root.querySelectorAll('[data-studio-language] form').forEach(form => {
      if (form.dataset.languageReady) return;
      form.dataset.languageReady = 'true';
      form.addEventListener('submit', () => {
        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.append(returnTo);
        }
        returnTo.value = location.pathname + location.search + location.hash;
      });
    });
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
